import { BrowserModule }            from '@angular/platform-browser'
import { BrowserAnimationsModule }  from '@angular/platform-browser/animations';
import { NgModule }                 from '@angular/core'
import { NgAisModule }              from 'angular-instantsearch'

import { AppComponent }             from './app.component'
import { MenuSelect }               from './modules/menuselect.module'
import { HotnessPipe }              from './helpers/hotness.pipe'
import { DateFormatterPipe }        from './helpers/dateformatter.pipe'
import { TitleFormatPipe }          from './helpers/titleformat.pipe'
import { AudioPlayerComponent }     from './audio-player/audio-player.component'
import { MixService }               from './mix-service.service'

@NgModule({
  declarations: [
    AppComponent,
    MenuSelect,
    HotnessPipe,
    DateFormatterPipe,
    TitleFormatPipe,
    AudioPlayerComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgAisModule.forRoot()
  ],
  providers: [
    MixService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/martyndavies/code/algolia/essentialvault-angular/src/app/app.module.ts